import { Greeting } from '@/components/home/Greeting';
import { KpiGrid } from '@/components/home/KpiGrid';
import { QuickActions } from '@/components/home/QuickActions';
import { RecentOrders } from '@/components/home/RecentOrders';
import { PullToRefresh } from '@/components/PullToRefresh';
import { useHomeData } from '@/hooks/useHomeData';
import '@/styles/home.css';

export function HomeRoute() {
  const { data, isLoading, refetch } = useHomeData();

  if (isLoading || !data) {
    return <div className="home" aria-busy="true" />;
  }

  return (
    <PullToRefresh onRefresh={async () => { await refetch(); }}>
      <div className="home">
        <Greeting />
        <KpiGrid items={data.kpis} />
        <QuickActions items={data.quickActions} />
        <RecentOrders items={data.recentOrders} />
      </div>
    </PullToRefresh>
  );
}
